import Select from "components/botanic/Select";
import Option from "components/Option";

const MonthSelect = ({
  defaultValue,
  onChange,
  id,
}: {
  defaultValue: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  onChange: (x: any) => void;
  id: string;
}) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <Select
      id={`${id}-month-select`}
      label="Month"
      defaultValue={defaultValue}
      onChange={onChange}
    >
      <Option value=""></Option>
      {months.map((month, i) => (
        <Option value={i + 1} key={month}>
          {month}
        </Option>
      ))}
    </Select>
  );
};

export default MonthSelect;
